import {resolve} from "../../../../container";
import {customElement, property, query} from "lit/decorators.js";
import {html, LitElement, type TemplateResult} from "lit";
import {EventBus} from "../../../../common/eventBus";
import Styles from "./newsSearchResultsTileTag.lit.scss";
import {NEWS_TAG_EVENT} from "../constants";
import {ClickTracking} from "../../../../tracking/clickTracking";
import {ShadowHighlightContextAware} from "../../../../common/elements";
import {handleActivationKey} from "../../../../common/utils/events";

@customElement("eop-news-search-results-tile-tag")
export class EopNewsSearchResultsTileTag extends ShadowHighlightContextAware(LitElement) {

    public static readonly styles = Styles;

    @property()
    public text: string;

    @query(".tag-container")
    private tagContainer: HTMLElement;

    public constructor(
        private eventBus: EventBus = resolve(EventBus),
        private clickTracking: ClickTracking = resolve(ClickTracking)
    ) {
        super();
    }

    public render(): TemplateResult {
        return html`
            <div class="tag-container reverse-background" @click=${this.handleClick} @keydown=${this.handleKeyDown} tabindex="0">
                <div class="tag">
                    ${this.text}
                </div>
            </div>
        `;
    }

    private handleKeyDown(event: KeyboardEvent): void {
        handleActivationKey(event, () => this.triggerNewsTagSelected(event));
    }

    private handleClick(event: Event): void {
        this.triggerNewsTagSelected(event);
    }

    private triggerNewsTagSelected(event: Event) : void {
        this.preventTrackingOfParentTile(event);
        this.clickTracking.handleTextlinkInteract(event, this.text);
        this.eventBus.dispatchEvent(NEWS_TAG_EVENT, {text: this.text});
    }

    private preventTrackingOfParentTile(event: Event): void {
        event.stopPropagation();
    }

    public focusableElement(): HTMLElement {
        return this.tagContainer;
    }
}